export function GetCurrentDate() {
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
    const day = String(currentDate.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

export function getCurrentTimeUnixTimestamp() {
    return Math.floor(Date.now() / 1000) // Convert milliseconds to seconds
  }
